import { CountyCmsOrganizationsTable } from './CountyCmsOrganizationsTable';
export default CountyCmsOrganizationsTable;
